import React from "react";
import { cn } from "../lib/helpers";
import Container from "./container";
import PortableText from "./portableText";

import * as styles from "../styles/components/main-content.module.css";

const SingleColumnContent = (props) => {

  const {
    content,
    heading
  } = props;

  return (
    <div className={styles.root}>
      <Container>
        {heading && <div className="content-xl"><h2 className={cn("h3", styles.heading)}>{heading}</h2></div>}
        {(content && content.length) 
          ? <div className="grid">
              {content.map(col => {
                return (
                  <div className="col-12 col-md-7 col-lg-6">
                    <div className="content-xl">
                      {col && <PortableText blocks={col._rawContent} />}
                    </div>
                  </div>
                );
              })}
            </div>
          : null
        }
      </Container>
    </div>
  );
}

export default SingleColumnContent;